import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";

interface AcceptRejectButtonsProps {
    onAccept: (event: React.MouseEvent<HTMLElement>) => void;
    onReject: (event: React.MouseEvent<HTMLElement>) => void;
    isAccepted?: boolean;
    isRejected?: boolean;
}

export const AcceptRejectTableButtons: React.FC<AcceptRejectButtonsProps> = ({
    onAccept,
    onReject,
    isAccepted,
    isRejected,
}) => {
    return (
        <div className="flex items-center gap-3">
            <Button
                onClick={(event) => {
                    event.stopPropagation();
                    onAccept(event);
                }}
                variant="filled"
                size="small"
                icon={<CheckOutlined style={{ color: isAccepted ? "white" : "#52C41A", fontSize: "0.9em" }} />}
                style={isAccepted ? { background: "#52C41A", color: "white" } : {}}
            />
            <Button
                onClick={(event) => {
                    event.stopPropagation();
                    onReject(event);
                }}
                variant="filled"
                size="small"
                icon={<CloseOutlined style={{ color: isRejected ? "white" : "#FF4D4F", fontSize: "0.9em" }} />}
                style={isRejected ? { background: "#FF4D4F", color: "white" } : {}}
            />
        </div>
    );
};
